// extracted by mini-css-extract-plugin
export default {"searchForm":"styles_searchForm__JBjh7"};